import axios from 'axios'
import { UserModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/auth-supplier`
export const REGISTER_URL = `${API_URL}/auth-supplier/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/auth-supplier/request-password-change`
export const FORGOT_PASSWORD_URL = `${API_URL}/auth-supplier/new-forgot-password`

// Server should return AuthModel
export function login(email: string, password: string) {
	return axios.post(LOGIN_URL, {
		email,
		password,
	})
}

// Server should return AuthModel
export function register(
	email: string,
	password: string,
	companyName: string,
	contactPersonFullname: string,
	contactPersonPosition: string,
	supplierType: string
) {
	const formData = new FormData()
	formData.append('email', email)
	formData.append('password', password)
	formData.append('companyName', companyName)
	formData.append('contactPersonFullname', contactPersonFullname)
	formData.append('contactPersonPosition', contactPersonPosition)
	formData.append('supplierType', supplierType)

	return axios.post(REGISTER_URL, formData)
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
	return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
		email,
	})
}

export function changePassword(token: string, password: string) {
	return axios.post(FORGOT_PASSWORD_URL, {
		token,
		password,
	})
}

export function getUserByToken(token: string) {
	return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
		api_token: token,
	})
}
